import { useContext, useState } from 'react';
import { Stack, Checkbox, Typography } from '@mui/material';
import DoneRoundedIcon from '@mui/icons-material/DoneRounded';
import { CreateTaskContext } from 'components/AllDialogs/tasks/createTask/context/context';
import CustomDropdown from 'components/Dropdown/CustomDropdown';
import ConfigurationIcon from 'components/Icons/sidebarIcons/configurationIcon';

const SettingOption = ({ isChecked, label, onClickHandler, type }) => {
  return (
    <Stack
      p="8px 12px"
      alignItems={'center'}
      borderRadius={'4px'}
      direction={'row'}
      bgcolor={isChecked ? 'rgba(235, 234, 255, 1)' : '#fff'}
      borderColor={
        isChecked ? 'rgba(104, 104, 254, 1)' : 'rgba(224, 224, 224, 1)'
      }
      gap="8px"
      justifyContent={'space-between'}
      onClick={() => {
        onClickHandler(type);
      }}
    >
      <Typography
        fontSize={'14px'}
        fontWeight={isChecked ? '600' : '400'}
        color={isChecked ? 'rgba(104, 104, 254, 1)' : '#212121'}
      >
        {label}
      </Typography>
      {isChecked && (
        <DoneRoundedIcon sx={{ color: 'rgba(104, 104, 254, 1)' }} />
      )}
    </Stack>
  );
};

const BulkTaskCreationSetting = () => {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const { updateTask, newTask } = useContext(CreateTaskContext);
  const [isSeparate, setIsSeparate] = useState(false);
  const [type, setType] = useState('tasksForAssignees');

  const createSeparateTasksHandler = (event) => {
    const checked = event?.target?.checked;
    setIsSeparate(checked);

    updateTask({
      isMultiTasks: checked,
    });
  };

  // const changeSettingsOptionsHandler = (type) => {
  //   setType(type);

  //   if (isSeparate) {
  //     updateTask({
  //       ...newTask,
  //       createSeparateTask: type,
  //     });
  //   }
  // };

  return (
    <Stack
      direction={'row'}
      alignItems={'center'}
      justifyContent={'space-between'}
      mt="12px"
      borderBottom="1px solid #E0E0E0"
      paddingBottom="15px"
    >
      <Stack direction={'row'} alignItems={'center'} gap="8px">
        <Checkbox
          sx={{ padding: '0px' }}
          onChange={createSeparateTasksHandler}
          checked={newTask?.isMultiTasks}
        />
        <Typography
          fontSize="14px"
          fontWeight="500"
          color="#000000"
          lineHeight="19.12px"
        >
          Create separate tasks for each assignee
        </Typography>
      </Stack>
      {/* <CustomDropdown
        handleCallback={(element) => {
          setIsDropdownVisible(element ? true : false);
        }}
        onClickawayCallback={() => {
          setIsDropdownVisible(false);
        }}
        popperProps={{
          content: (
            <Stack p="20px">
              <Typography
                fontSize="14px"
                color="#212121"
                fontWeight={'700'}
                mb="4px"
              >
                Bulk Assignment Settings
              </Typography>
              <Typography
                fontSize="13px"
                color="#424242"
                fontWeight={'400'}
                mb="12px"
              >
                Set default option for bulk task assignment
              </Typography>
              <Stack gap="12px" width="340px">
                <SettingOption
                  isChecked={type === 'tasksForAssignees'}
                  label={'Create separate tasks for each assignee'}
                  onClickHandler={changeSettingsOptionsHandler}
                  type="tasksForAssignees"
                />
                <SettingOption
                  isChecked={type === 'tasksForMembers'}
                  label={
                    'Create separate tasks for every member of each assignee'
                  }
                  onClickHandler={changeSettingsOptionsHandler}
                  type="tasksForMembers"
                />
              </Stack>
            </Stack>
          ),
        }}
        iconButton
      >
        <ConfigurationIcon
          sx={{
            fontSize: '20px',
            fill: isDropdownVisible
              ? 'rgba(104, 104, 254, 1) !important'
              : 'rgba(117, 117, 117, 1) !important',
            '& path': {
              stroke: isDropdownVisible
                ? 'rgba(104, 104, 254, 1)'
                : 'rgba(117, 117, 117, 1)',
            },
          }}
        />
      </CustomDropdown> */}
    </Stack>
  );
};

export default BulkTaskCreationSetting;
